<template>
  <v-container fluid>
    <v-toolbar color="white" flat>
      <v-toolbar-title>LotoJR</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="incluirConcurso()">Incluir</v-btn>
    </v-toolbar>
    <v-dialog v-model="dialog" persistent max-width="900">
      <v-card>
        <v-card-title>
          Dados do concurso
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.concurso"
                label="Concurso"
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="concurso.informacao"
                label="Informação"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.identificador"
                label="Identificador"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="concursoCondicao"
                label="Condição"
                item-text="label"
                required
                v-model="concurso.condicao"
                @change="onChangeCondicao($event)"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.valor"
                label="Valor"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.datainicial"
                v-mask="'##/##/####'"
                label="Data Inicial"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.datafinal"
                v-mask="'##/##/####'"
                label="Data Encerramento"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.horafinal"
                v-mask="'##:##'"
                label="Hora final"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.percapoiador"
                label="% apoiador"
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="concurso.percapoiadores"
                label="% apoiadores"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.percconquista"
                label="% Conquista"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="concurso.percsistema"
                label="% sistema"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <number-selector
                :key="numberSelectorKey"
                ref="numberSelectorRef"
                :qtde="25"
                v-model="concurso.numeros"
              ></number-selector>
            </v-col>
            <v-col cols="7">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="concurso.totalarrecadado"
                    label="Total arrecadação"
                    type="number"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    color="primary"
                    :disabled="this.concurso.condicao == 'A'"
                    dark
                    @click="findComprasGanhadoras()"
                    >Buscar Ganhadores</v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="concurso.pontuacaomaxima"
                    label="Pontuação máxima"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="concurso.valorliquido"
                    label="Valor liquido"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="concurso.parabens"
                    label="Parabéns"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="concurso.descricao"
                label="Descrição"
                outlined
                rows="5"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="concurso.regras"
                label="Regras"
                outlined
                rows="5"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn ma-2 text small color="primary" @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            ma-2
            text
            small
            color="primary"
            :loading="loading"
            @click="save()"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :key="planosKey"
      :headers="headers"
      :items="concursosLotoJR"
      :items-per-page="10"
      :loading="loading"
      :no-data-text="loading ? 'Carregando' : 'Nenhum Registro para mostrar'"
      class="elevation-1"
    >
      <template v-slot:[`item.datainicial`]="{ item }">
        <span>{{ formatDate(item.datainicial) }}</span>
      </template>
      <template v-slot:[`item.datafinal`]="{ item }">
        <span>{{ formatDate(item.datafinal) }}</span>
      </template>
      <template v-slot:[`item.condicao`]="{ item }">
        <span>{{ item.condicao == "A" ? "Aberto" : "Fechado" }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <span style="margin-right: 10px;">
          <v-icon small @click="editConcurso(item)">edit</v-icon></span
        >
        <span> <v-icon small @click="deleteItem(item)">delete</v-icon></span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import NumberSelector from "../../components/number-selector.vue";
export default {
  components: {
    "number-selector": NumberSelector,
  },
  data() {
    return {
      action: "",
      dialog: false,
      concurso: {},
      concursosLotoJR: [],
      loading: false,
      planosKey: 0,
      numberSelectorKey: 0,
      ganhadoresCalculados: false,
      numberLength: 1,
      oldNumber: [],
      concursoCondicao: [
        { value: "A", label: "Ativo" },
        { value: "F", label: "Finalizado" },
      ],
      headers: [
        { text: "", value: "actions", sortable: false },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "condicao",
        },
        {
          text: "Concurso",
          align: "left",
          sortable: true,
          value: "concurso",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
        {
          text: "Data Início",
          align: "left",
          sortable: true,
          value: "datainicial",
        },
        {
          text: "Data fim",
          align: "left",
          sortable: true,
          value: "datafinal",
        },
      ],
    };
  },

  watch: {
    "concurso.numeros"(newVal) {
      this.ganhadoresCalculados = false;

      this.oldNumber = [...newVal];
    },
  },
  created() {
    this.fetchConcursos();
  },
  methods: {
    incluirConcurso() {
      this.action = "incluir";
      this.concurso = {};
      this.dialog = true;
    },
    editConcurso(value) {
      this.action = "edit";
      this.concurso = { ...value };
      this.concurso.datainicial = this.formatDate(this.concurso.datainicial);
      this.concurso.datafinal = this.formatDate(this.concurso.datafinal);
      this.concurso.numeros = [];
      this.dialog = true;
    },
    onChangeCondicao(condicao) {
      this.concurso.condicao = condicao;
    },
    save() {
      if (this.action == "incluir") {
        this.onSave();
      } else {
        if (
          this.concurso.condicao == "F" &&
          this.concurso.numeros.length < this.numberLength
        ) {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Selecione os números sorteados",
          });
        } else if (
          this.concurso.condicao == "F" &&
          !this.ganhadoresCalculados
        ) {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Clique em Buscar Ganhadores",
          });
        } else {
          this.onUpdate();
        }
      }
    },

    onSave() {
      this.loading = true;
      this.$store
        .dispatch("saveConcursoLotoJR", this.concurso)
        .then((value) => {
          this.$store.dispatch("setNotification", {
            type: "info",
            text: "Concurso adicionado",
          });
          this.dialog = false;
          this.fetchConcursos();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao salvar os planos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    findComprasGanhadoras() {
      if (this.concurso.numeros.length < this.numberLength) {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: "Selecione os numeros sorteados",
        });
      } else {
        this.loading = true;
        this.$store
          .dispatch("findComprasGanhadorasConcursoLotoJr", {
            id: this.concurso.id,
            numeros: this.concurso.numeros,
          })
          .then((value) => {
            let qtdeGanhadores = value.length;
            if (value.length > 0) {
              this.concurso.pontuacaomaxima = value[0].count;
              this.concurso.valorliquido =
                (this.concurso.percconquista * this.concurso.totalarrecadado) /
                100 /
                qtdeGanhadores;
            }

            this.ganhadoresCalculados = true;
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onUpdate() {
      this.loading = true;
      this.$store
        .dispatch("updateConcursoLotoJR", this.concurso)
        .then((value) => {
          this.$store.dispatch("setNotification", {
            type: "info",
            text: "Concurso Atualizado com sucesso",
          });
          this.dialog = false;
          this.fetchConcursos();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao Atualizar o concurso",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchConcursos() {
      this.loading = true;
      this.$store
        .dispatch("fetchConcursosLotoJR")
        .then((value) => {
          this.planosKey += 1;
          this.concursosLotoJR = value;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os concursos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
